import { render, staticRenderFns } from "./ImeiHistoryCell.vue?vue&type=template&id=48d41b19&scoped=true"
import script from "./ImeiHistoryCell.vue?vue&type=script&lang=js"
export * from "./ImeiHistoryCell.vue?vue&type=script&lang=js"
import style0 from "./ImeiHistoryCell.vue?vue&type=style&index=0&id=48d41b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d41b19",
  null
  
)

export default component.exports